module.exports = __webpack_public_path__ + "static/img/图层 51.50068b07.png";